import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedDetailMeasurement from './helpers/PdpSharedDetailMeasurement';

// helpers
import get from 'lodash.get';

function PdpSharedDetailInseam({ item }) {
    return (
        <PdpSharedDetailMeasurement
            dataTn="pdp-spec-inseam"
            measurements={get(item, 'measurement.inseam')}
        />
    );
}

PdpSharedDetailInseam.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailInseam, {
    item: graphql`
        fragment PdpSharedDetailInseam_item on Item {
            measurement {
                inseam: display(fields: [inseam]) {
                    ...PdpSharedDetailMeasurement_measurements
                }
            }
        }
    `,
});
